import axios from 'axios';
import { navigate } from './navigationService';
import { saveReturnTo } from './returnTo';

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Probe endpoint: a 401 here is an expected answer (not logged in), not a reason to redirect
export const AUTH_HEALTH_URL = '/v1/auth/health';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds timeout
  withCredentials: true, // Send session cookies with requests
});

// Response interceptor - handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log only non-sensitive metadata: the full error carries request/response bodies (PII)
    const method = error.config?.method?.toUpperCase();
    const url = error.config?.url;
    const status = error.response?.status;
    const message = error.response?.data?.message ?? error.message;
    console.error('API Error:', method, url, status, message);
    const isAuthProbe = url === AUTH_HEALTH_URL;
    if (status === 401 && !isAuthProbe) {
      saveReturnTo(window.location.pathname + window.location.search);
      navigate('/login');
    }
    return Promise.reject(error);
  }
);

export default apiClient;
